<template>
  <v-card
    v-if="event.isRest"
    hover
    outlined
    color="#ddddddaa"
    class="cell-event rest"
    :class="{
      selected: selected,
    }"
    @click="() => onRestClick(event._id.split('-')[2] || event._id)"
  >
    <div class="caption">
      {{ event.restName || 'Blocked' }} <br />
      {{ event.remarks | parseAndLocalize('en') }}
    </div>
  </v-card>
  <v-card
    v-else
    v-bind="$attrs"
    hover
    class="cell-event"
    :class="{
      selected: selected,
      newCustomer: !get(event, 'booking.created_by.oldCustomer', false),
      ['status-' + parseInt(get(event, 'booking.status'))]: true,
    }"
    :style="{ borderColor, backgroundColor: color }"
    @click="() => onEventClick(event._id)"
  >
    <!-- New Badge (Top Right Corner) -->
    <div v-if="isNewBooking" class="new-badge">NEW</div>

    <div class="event-content">
      <!-- Left: Icon -->
      <div class="event-icon">
        <v-icon size="20" color="#666" v-if="event.booking.serviceDetails.service.mdiIcon">
          {{ event.booking.serviceDetails.service.mdiIcon }}
        </v-icon>
      </div>

      <!-- Center: Service and Patient Info -->
      <div class="event-details">
        <!-- Line 1: Service Name -->
        <div class="service-name">[{{ getServiceName(event) }}]</div>
        <!-- Line 2: Patient Name and Contact -->
        <div class="patient-info">
          <span class="patient-name">{{ getPatientName(event) }}</span>
          <span class="contact-number">{{ getContactNumber(event) }}</span>
        </div>
      </div>

      <!-- Right: Ticket Number -->
      <div class="ticket-number">#{{ getTicketNumber(event) }}</div>
      <div
        v-if="
          event.booking.isExpired &&
          event.booking.status !== BookingStatus.completed &&
          event.booking.status !== BookingStatus.absent
        "
        class="expired-badge"
      >
        !
      </div>
    </div>
    <!-- <v-container class="py-0" style="z-index: 1">
      <v-row dense no-gutters>
        <v-col class="d-flex align-baseline">
          <gender-label
            :maleColor="color"
            :femaleColor="color"
            :hideLabel="true"
            :size="iconSize"
            gender="F"
            :color="color"
          />
          <span :style="{ color: color }" class="mr-1">{{ event.booking.created_by.sid }}</span>
          <span style="font-size: 12px">{{ event.booking.created_by.name }}</span>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="12" class="d-flex align-baseline">
          <v-icon :size="iconSize" :color="color">mdi-clock</v-icon>
          {{ event.time.start | moment('HH:mm A') }}- {{ event.time.end | moment('HH:mm A') }} ({{
            timeDuration({ start: event.time.start, end: event.time.end })
          }})
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col cols="12" class="d-flex align-baseline flex-wrap">
          <div class="mr-2">
            <v-icon :size="iconSize" :color="color">mdi-phone</v-icon>
            {{ event.booking.created_by.phone | displayPhone }}
          </div>
          <div>
            <v-icon :size="iconSize" :color="color">mdi-star</v-icon>
            {{ event.booking.created_by.precautions }}
          </div>
        </v-col>
      </v-row>
      <v-row dense no-gutters>
        <v-col class="d-flex" style="gap: 8px">
          <v-chip x-small color="primary"><v-icon>mdi-account-check</v-icon> Arrived</v-chip>
          <v-chip x-small color="primary"
            ><v-icon>mdi-calendar-check</v-icon> Consultation Finished</v-chip
          >
        </v-col>
      </v-row>
    </v-container> -->
  </v-card>
</template>

<script>
import { timeDuration } from '@/services/filters';
import { BookingStatus } from '@/api/bookings';
import { get } from 'lodash';
import moment from 'moment';
import { genderType } from '@/data/constants';

export default {
  components: {},
  data() {
    return {
      BookingStatus,
      iconSize: '14px',
    };
  },
  props: {
    event: {
      type: Object,
      default: () => {},
    },
    color: {
      type: String,
      default: '#cccccc',
    },
    borderColor: {
      type: String,
      default: '#cccccc',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isSmall() {
      const s = moment(this.event.time.start);
      const e = moment(this.event.time.end);
      const duration = moment.duration(moment(e).diff(s));
      const minutes = parseInt(duration.asMinutes());
      return minutes <= 5;
    },
    iconColor() {
      const gender = this.event.booking.created_by.gender;
      if (gender === genderType.Male) {
        return this.$vuetify.theme.themes.light.genderMale_dark;
      }
      if (gender === genderType.Female) {
        return this.$vuetify.theme.themes.light.genderFemale_dark;
      }
      return this.$vuetify.theme.themes.light.genderUnknown_dark;
    },
    isConfirmedArrive() {
      return this.event.booking?.isConfirmedArrive;
    },
    phoneColor() {
      return this.isConfirmedArrive ? '#A5CF4C' : this.iconColor;
    },
    isNewBooking() {
      // Check if booking has not been read by clinic staff yet
      return !this.event.booking?.clinicReadAt;
    },
  },
  methods: {
    get,
    timeDuration,
    onEventClick(eventId) {
      this.$emit('onEventClick', eventId);
    },
    onRestClick(eventId) {
      this.$emit('onRestClick', eventId);
    },
    getSeat(s) {
      const chars = ['0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];
      return s && (chars[s] || s.replace(/[0-9]/g, x => chars[x]));
    },
    getServiceName(event) {
      // Try to get service name from serviceDetails
      const serviceName = get(event, 'booking.serviceDetails.service.name');
      if (serviceName) {
        // Parse if it's a JSON string
        try {
          const parsed = JSON.parse(serviceName);
          return parsed.en || parsed['zh-hk'] || 'Service';
        } catch (e) {
          return serviceName;
        }
      }
      return 'Specialists (1st appointment)';
    },
    getPatientName(event) {
      return (
        get(event, 'booking.serviceDetails.patient.name') ||
        get(event, 'booking.created_by.name') ||
        'Patient'
      );
    },
    getContactNumber(event) {
      const phone =
        get(event, 'booking.serviceDetails.contactNumber') ||
        get(event, 'booking.created_by.phone');
      return phone ? phone.replace(/(\+852\s?)/, '+852 ') : '';
    },
    getTicketNumber(event) {
      return get(event, 'booking.ticketNumber', 'N/A');
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-event {
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 0px;
  font-size: 12px;
  padding: 8px;
  background-color: #fef9e7;
  min-height: 60px;

  .event-content {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 100%;
  }

  .event-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;

    flex-shrink: 0;
  }

  .event-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0; // Allow text truncation
    align-items: flex-start;
    .service-name {
      font-size: 11px;
      font-weight: 600;
      color: #333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .patient-info {
      display: flex;
      gap: 8px;
      font-size: 10px;
      color: #666;

      .patient-name {
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .contact-number {
        flex-shrink: 0;
        color: #999;
      }
    }
  }

  .ticket-number {
    font-size: 18px;
    font-weight: 700;
    color: #666;
    flex-shrink: 0;
  }

  .expired-badge {
    font-size: 30px;
    font-weight: 700;
    color: red;
  }

  .new-badge {
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: #f00;
    color: white;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 4px;
    border-radius: 3px 0 3px 3px;
    z-index: 2;
    line-height: 1;
  }

  &.rest {
    background-color: #f5f5f5;
    padding: 4px;
    overflow: hidden;
    text-align: center;
    color: #999;
  }

  // &.assistant {
  //   background-color: #ffcc88;
  // }

  // &.status-97, // 97$cancelled
  // &.status-98 // 98$absent
  // {
  //   opacity: 0.5;
  // }

  // &.selected {
  //   outline: 3px solid red !important;
  // }

  // &.newCustomer {
  //   border: 2px solid rgb(255, 214, 82);
  // }
}
</style>
